import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`This action sets, overwrites, or removes any existing value for `}<inlineCode parentName="p">{`shippingAddress`}</inlineCode>{`.`}<br parentName="p"></br>{`
`}{`Changing the shipping address does not recalculate the cart. The taxes might not fit to the shipping address anymore.`}<br parentName="p"></br>{`
`}{`This action does not change the shipping address on the `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#cart"
        }}>{`Cart`}</a>{` the order has been created from.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setShippingAddress"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`address`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#addressdraft"
          }}>{`AddressDraft`}</a>{` - Optional`}</li>
      </ul>
      <p parentName="section">{`This update action produces an `}<a parentName="p" {...{
          "href": "/api/../api/message-types#ordershippingaddresssetmessage"
        }}>{`OrderShippingAddressSetMessage`}</a>{`.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      